export const contactUsMail = (form) => {
    return `<p>Hello Indotech!</p>
            <p>&nbsp;</p>
            <p>You got a new contact request from ${form.businessName || 'unknown business'}<br><br></p>
            <p><br><br>Here are the information about the request:<br><br>First Name: ${form.firstName}</p>
            <p>Last Name: ${form.lastName}</p>
            <p>Phone Number: ${form.phone}</p>
            <p>Email: ${form.email}</p>
            <p>Job title: ${form.jobTitle}</p>
            <p>Industry: ${form.industry}</p>
            <p>Product Range: ${form.productRange}</p>
            <p>Preferred Communication: ${form.communication}</p>
            <p> </p>
            <p style="padding: 12px; border-left: 4px solid #d0d0d0; font-style: italic;">${form.message}</p>
            <p>&nbsp;</p>
            <p>Best wishes, go get it!</p>
           `;
};

export const quoteMail = (form) => {
    return `<p>Hello Indotech!</p>
            <p>&nbsp;</p>
            <p>You got a new quote submission from ${form.businessName || 'unknown business'}<br><br></p>
            <p><br><br>Here are the information about the submission:<br><br>First Name: ${form.firstName}</p>
            <p>Last Name: ${form.lastName}</p>
            <p>Phone Number: ${form.phone}</p>
            <p>Email: ${form.email}</p>
            <p>Job title: ${form.jobTitle}</p>
            <p>Door Type: ${form.doorType}</p>
            <p>Door Model: ${form.doorModel}</p>
            <p>Curtain Color: ${form.curtain}</p>
            <p>Dimensions (width x height, quantity):</p>
            <ul>
                <li>Door 1: ${form.width1} x ${form.height1}, qty: ${form.qty1} </li>
                <li>Door 2: ${form.width2} x ${form.height2}, qty: ${form.qty2} </li>
                <li>Door 3: ${form.width3} x ${form.height3}, qty: ${form.qty3} </li>
            </ul>
            <p>Door Installation: ${form.doorInstallation}</p>
            <p>Operator Voltage: ${form.operatorTension}</p>
            <p>Operator Installation: ${form.operatorInstallation}</p>
            <p>Electrical: ${form.electrical}</p>
            <p>Guide Rails: ${form.guides}</p>
            <p>Expedition : ${form.expedition}</p>
            <p> </p>
            <p style="padding: 12px; border-left: 4px solid #d0d0d0; font-style: italic;">${form.message}</p>
            <p>&nbsp;</p>
            <p>Best wishes, go get it!</p>
           `;
};

export const quoteConfirmationMail = (form, t) => {
    return `<p>${t('confirmation.greeting', { firstName: form.firstName })}</p>
            <p>&nbsp;</p>
            <p>${t('confirmation.intro')}</p>
            <p>&nbsp;</p>
            <p>${t('sections.contactDetails.firstName')}: ${form.firstName}</p>
            <p>${t('sections.contactDetails.lastName')}: ${form.lastName}</p>
            <p>${t('sections.contactDetails.phone')}: ${form.phone}</p>
            <p>${t('sections.contactDetails.email')}: ${form.email}</p>
            <p>${t('sections.contactDetails.jobTitle')}: ${form.jobTitle}</p>
            <p>${t('sections.doorType.sectionTitle')}: ${form.doorType}</p>
            <p>${t('sections.doorModel.sectionTitle')}: ${form.doorModel}</p>
            <p>${t('sections.doorModel.subSections.curtain.title')}: ${form.curtain}</p>
            <p>${t('sections.dimensions.sectionTitle')} (${t('sections.dimensions.width')} x ${t('sections.dimensions.height')}, ${t('sections.dimensions.quantity')}):</p>
            <ul>
                <li>${t('sections.dimensions.subSections.door1')}: ${form.width1} x ${form.height1}, ${t('sections.dimensions.quantity').toLowerCase()}: ${form.qty1}</li>
                <li>${t('sections.dimensions.subSections.door2')}: ${form.width2} x ${form.height2}, ${t('sections.dimensions.quantity').toLowerCase()}: ${form.qty2}</li>
                <li>${t('sections.dimensions.subSections.door3')}: ${form.width3} x ${form.height3}, ${t('sections.dimensions.quantity').toLowerCase()}: ${form.qty3}</li>
            </ul>
            <p>${t('sections.installation.sectionTitle')}: ${form.doorInstallation}</p>
            <p>${t('sections.operator.subSections.voltage')}: ${form.operatorTension}</p>
            <p>${t('sections.operator.subSections.installation.title')}: ${form.operatorInstallation}</p>
            <p>${t('sections.electrical.sectionTitle')}: ${form.electrical}</p>
            <p>${t('sections.guides.sectionTitle')}: ${form.guides}</p>
            <p>${t('sections.expedition.sectionTitle')}: ${form.expedition}</p>
            <p> </p>
            <p style="padding: 12px; border-left: 4px solid #d0d0d0; font-style: italic;">${form.message}</p>
            <p>&nbsp;</p>
            <p>${t('confirmation.closing')}</p>
            <p>&nbsp;</p>
            <p>Indotech</p>
           `;
};
